import gql from "graphql-tag";

export default gql`

mutation jobStart($jobId: String!) {
  jobStart(id: $jobId)
}

`